module.exports = __webpack_public_path__ + "img/澳洲站.ef332306.png";